import { PageNoNavigation } from "@components/templates/PageNoNavigation/PageNoNavigation"
import { FC, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import ThemedLoginPage from "../components/ThemedLoginPage"
import { useMantineColorScheme } from "@mantine/core"
import { useAuthContext } from "../context/AuthProvider"

const LoginPage: FC = () => {
	const { isAuthenticated } = useAuthContext()
	const navigate = useNavigate()
	const { setColorScheme } = useMantineColorScheme()
	useEffect(() => {
		if (isAuthenticated) {
			navigate("/home")
		}
		setColorScheme("light")
	}, [isAuthenticated, navigate])

	return (
		<PageNoNavigation>
			<ThemedLoginPage />
		</PageNoNavigation>
	)
}

export default LoginPage
